import { Link } from "react-router-dom";
import Reveal from "../ui/Reveal";
import Accordion from "../ui/Accordion";
import { COMPANY } from "../data/company";
import { FAQ } from "../data/faq";
import "./faq.css";

export default function Faq() {
  return (
    <section className="section faq" id="faq">
      <div className="container container--wide faq__inner">
        <div className="faq__head">
          <Reveal>
            <h2 className="t-display-2 faq__title">Before you start.</h2>
          </Reveal>
          <Reveal delay={0.06}>
            <p className="t-lead faq__aside">
              Anything not here, ask us at{" "}
              <a href={`mailto:${COMPANY.supportEmail}`}>
                {COMPANY.supportEmail}
              </a>
              , or read the <Link to="/help">help page</Link>.
            </p>
          </Reveal>
        </div>

        <Accordion
          items={FAQ}
          getKey={(item) => item.q}
          render={(item) => <p className="t-body">{item.a}</p>}
        />
      </div>
    </section>
  );
}
